import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  doc,
  getDoc,
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { firebaseApp } from "../../firebase";
import NavBar from "../../components/Navigation/NavBar";
import Footer from "../../components/Footer/Footer";
import { XMarkIcon } from "@heroicons/react/24/solid";
import TopAlert from "../../components/Alerts/TopAlert";
import { Helmet } from "react-helmet";
import { ArrowPathIcon } from "@heroicons/react/24/outline"; // add this import
import FormSubmissionModal from "../../components/Modal/FormSubmissionModal";
import FormPageV1 from "../../components/Forms/FormPageV1";
import FormPageV2 from "../../components/Forms/FormPageV2";


const FormsPage = ({ preview }) => {
  const { id } = useParams();
  const db = getFirestore(firebaseApp);
  const [formData, setFormData] = useState(null);

  // Track answers and repeatable sections
  const [error, setError] = useState("");


  useEffect(() => {
    const loadForm = async () => {
      try {
        if (preview) {
          const previewForm = sessionStorage.getItem("previewForm");
          if (previewForm) setFormData(JSON.parse(previewForm));
          else setError("No preview form available.");
        } else {
          const formDoc = await getDoc(doc(db, "forms", id));
          const data = formDoc.data();
          if (formDoc.exists()) {
            if (data.sgloopGroup) {
              try {
                const sgloopGroupRef = data.sgloopGroup; // This is a DocumentReference
                const sgloopGroupSnap = await getDoc(sgloopGroupRef);

                if (sgloopGroupSnap.exists()) {
                  const sgloopGroupData = {
                    id: sgloopGroupSnap.id,
                    ...sgloopGroupSnap.data(),
                    path: sgloopGroupRef.path, // Save path for localStorage redirect
                  };
                  data.sgloopGroupData = sgloopGroupData;
                }
              } catch (err) {
                console.error("Error fetching SGloop group:", err);
              }
            }
            setFormData(data);

          }
          else setError("Form not found.");
        }
      } catch (err) {
        console.error("Error loading form:", err);
        setError("Failed to load form.");
      }
    };
    loadForm();
  }, [id, preview]);




  // ---------------- Render ----------------
  return (
    <>
      {formData?.backendVersion == 2 ? <FormPageV2 parentFormData={formData}></FormPageV2> 
      : <FormPageV1 parentFormData={formData}></FormPageV1>}
    </>
  );
};

export default FormsPage;
